module.exports = __webpack_public_path__ + "03_bob_grey.227a8512.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_bob_grey.png
// module id = fw/C
// module chunks = 0